var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "vld-parent"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-plus' ></i> Tambah File"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No. BL/AWB"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'is-invalid': _vm.errors.has('No B/L')
    },
    attrs: {
      "type": "text",
      "name": "No B/L",
      "id": "ccnumber",
      "placeholder": "Nomor BL/AWB"
    },
    model: {
      value: (_vm.form.no_bl),
      callback: function($$v) {
        _vm.form.no_bl = $$v
      },
      expression: "form.no_bl"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No B/L')),
      expression: "errors.has('No B/L')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                      " + _vm._s(_vm.errors.first('No B/L')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal BL/AWB"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'is-invalid': _vm.errors.has('Tanggal B/L')
    },
    attrs: {
      "type": "date",
      "name": "Tanggal B/L",
      "placeholder": "Nomor BL/AWB"
    },
    model: {
      value: (_vm.form.tgl_bl),
      callback: function($$v) {
        _vm.form.tgl_bl = $$v
      },
      expression: "form.tgl_bl"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal B/L')),
      expression: "errors.has('Tanggal B/L')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                      " + _vm._s(_vm.errors.first('Tanggal B/L')) + "\n                    ")])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "file",
      "name": "file"
    },
    on: {
      "change": _vm.targetFiles
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('file')),
      expression: "errors.has('file')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('file')) + "\n              ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": [{
          text: 'Perusahaan Jasa Titipan',
          value: '1'
        },
        {
          text: 'Agen Pengangkut',
          value: '2'
        }
      ],
      "name": "Jenis Perusahaan"
    },
    model: {
      value: (_vm.form.jn_perusahaan),
      callback: function($$v) {
        _vm.form.jn_perusahaan = $$v
      },
      expression: "form.jn_perusahaan"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Perusahaan')),
      expression: "errors.has('Jenis Perusahaan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Jenis Perusahaan')) + "\n              ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": [{
          text: 'Luar Daerah Pabean ke Kawasan Bebas',
          value: '1'
        },
        {
          text: 'Kawasan Bebas ke TLDDP',
          value: '2'
        }
      ],
      "name": "Tujuan"
    },
    model: {
      value: (_vm.form.kd_tujuan),
      callback: function($$v) {
        _vm.form.kd_tujuan = $$v
      },
      expression: "form.kd_tujuan"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tujuan')),
      expression: "errors.has('Tujuan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Tujuan')) + "\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 pl-4"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "md",
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Kirim")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ml-auto pr-4"
  }, [_c('router-link', {
    attrs: {
      "to": "/rekonmanifes/browse"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" Back")])])], 1)])], 1)])]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3d4a5da","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/RekonManifes/addbl.vue
// module id = 326
// module chunks = 0